import React, { useEffect, useState } from 'react'
import { Col, Grid, Row } from 'react-bootstrap'
import CountryWarnings from '../../../Ambasador/Components/CountryWarnings'
import AmbassadorStatusChange from '../../StatusChange/AmbassadorStatusChange'
import { AmbassadorSection } from '../../../../../../Components/City/Page/Ambassador/AmbassadorSection'
import { SectionTitle } from '../../../../../../Components/Section/SectionTitle'
import { LinkExternal } from '../../../../../../Components/LinkExternal'
import EditIcon from '@material-ui/icons/Edit'
import StyledIconButton from '../../../../../../Components/Form/StyledIconButton'
import { useHistory } from 'react-router-dom'

const IdentificationFilesSection = ({
  ambassador,
  ambassadorDocuments,
  cities,
  handleUserActions,
}) => {
  const history = useHistory()
  const [countryCode, setCountryCode] = useState(null)
  const [status, setStatus] = useState(false)

  useEffect(() => {
    if (cities.length > 0) {
      let city = cities.find(cities => ambassador.city.id === cities.id)
      setCountryCode(city.country.countryCode)
    }
  }, [cities])

  useEffect(() => {
    if (ambassador) {
      if (ambassador && ambassador.status === 'waiting_for_review') {
        setStatus(true)
      } else {
        setStatus(false)
      }
    }
  }, [ambassador])

  return (
    <AmbassadorSection>
      <Grid fluid>
        <Row>
          <Col xs={12}>
            <SectionTitle>Identification Files</SectionTitle>
            <StyledIconButton
              style={{ float: 'right' }}
              onClick={() =>
                history.push(history.location.pathname + '/upload-documents')
              }
            >
              <EditIcon />
            </StyledIconButton>
          </Col>
        </Row>
        {ambassadorDocuments.length ? (
          <div>
            <Row>
              {ambassadorDocuments.map(doc => (
                <Col xs={3} key={doc.id}>
                  <p className="col-title">ID Prof {doc.id}</p>
                  <LinkExternal href={doc.url} target="_blank">
                    Click here
                  </LinkExternal>
                </Col>
              ))}
            </Row>
          </div>
        ) : (
          <p>no files available</p>
        )}

        <CountryWarnings country={countryCode} status={status} />

        <AmbassadorStatusChange
          ambassadorStatus={ambassador.status}
          onChange={handleUserActions}
          disabled={!!ambassador.isLoading}
        />
      </Grid>
    </AmbassadorSection>
  )
}

export default IdentificationFilesSection



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Spies/Components/IdentificationFilesSection/index.js